import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from './thunkMiddleware';
import createRootReducer from '../state/reducers';
import createPersistReducer from './createPersistReducer';
import IStore from './store.interface';

const configureStore = (initialState: Partial<IStore> = {}): Store<IStore> => {
    const composeFunction = composeWithDevTools({ name: 'comm-center' });
    const rootReducer = createRootReducer();
    const persistedReducer = createPersistReducer(rootReducer);
    return createStore(persistedReducer, initialState as $TSFixMe, composeFunction(applyMiddleware(thunkMiddleware)));
};

export default configureStore;
